const allowedPageNames = [
	'Billing Portal',
	'Profile',
	'Workspace Settings',
	'Help',
	'Admin',
	'Admin Stats',
	'Home',
	'Brands',
	'Multiplayer',
	'Uploads',
	'MCP Server',
];

export function canAccessDeactivatedPage(route) {
	return allowedPageNames.includes(route.name);
}
